import { colors } from '@material-ui/core';

export default (palette) => ({
  root: {
    backgroundColor: palette.black === '#2D2D2D' ? '#4D4F4F' : colors.grey[50]
  }
});
